import { render, staticRenderFns } from "./StatusDot.vue?vue&type=template&id=1fbb4e72&scoped=true&"
import script from "./StatusDot.vue?vue&type=script&lang=js&"
export * from "./StatusDot.vue?vue&type=script&lang=js&"
import style0 from "./StatusDot.vue?vue&type=style&index=0&id=1fbb4e72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbb4e72",
  null
  
)

export default component.exports